import { faCircleStar } from '@fortawesome/pro-solid-svg-icons/faCircleStar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FunctionComponent } from 'react';

export interface MembershipIconProps {
    className?: string;
}

export const MembershipIcon: FunctionComponent<MembershipIconProps> = props => {
    return (
        <FontAwesomeIcon
            icon={faCircleStar}
            className={props.className}
            color="#EAB464"
        />
    );
};

export default MembershipIcon;
